<div class="ticket-selection-list">
  <ng-container *ngIf="ticketList$ | async as ticketList">
    <div class="mb-4">
      <fgbcl-ticket-transfer-status (onRefresh)="refresh()" />
    </div>
    <ng-container *ngIf="ticketList.length > 0; else noTickets">
      <ng-container *ngIf="isWindowOpen$ | async">
        <h5 class="fw-bold mb-1 font-size-18">{{ 'tickets.page.ticket.title' | translate }}</h5>
        <p class="font-size-14 mb-4" [innerHtml]="'tickets.page.ticket.instruction' | translate"></p>

        <!-- Hide select All button if items is less than 1 -->
        <div class="ticket-list-select-all form-check" *ngIf="showSelectAll">
          <input
            type="checkbox"
            class="form-check-input"
            id="selectAll"
            name="selectAll"
            (change)="selectAll()"
            [checked]="!anyUnselected"
          />
          <label for="selectAll" class="form-check-label">{{ 'fgbcl.ticket.list.select.all.tickets' | translate }}</label>
        </div>
        <!-- Available Ticket List -->
        <fgbcl-ticket-list
          [filters]="activeFilter"
          [sortOptions]="sortOptions"
          [transferWindowExists]="transferWindowExist$ | async"
          [transferWindowOpen]="isWindowOpen$ | async"
          (onDataChange)="onActiveDataSourceChange($event)"
        >
          <div class="ticket-list-no-data">
            <ng-container
              *ngTemplateOutlet="
                noData;
                context: { $implicit: 'fgbcl.ticket.selection.list.available.no.data.message' | translate }
              "
            ></ng-container>
          </div>
        </fgbcl-ticket-list>

        <!-- Transferred Tickets-->
        @if (showTransferTitle) {
          <h5 class="fw-bold mb-1 font-size-18">{{ 'tickets.page.ticket.transferred.title' | translate }}</h5>
          <p class="font-size-14 mb-4" [innerHtml]="'tickets.page.ticket.transferred.instruction' | translate"></p>
        }
        <fgbcl-ticket-list
          [filters]="transferredFilter"
          [sortOptions]="sortOptions"
          [transferWindowExists]="false"
          [transferWindowOpen]="isWindowOpen$ | async"
          (onDataChange)="onTransferredDataChange($event)"
        ></fgbcl-ticket-list>
      </ng-container>

      <ng-container *ngIf="!(isWindowOpen$ | async)">
        @if (showActiveTitle) {
          <h5 class="fw-bold mb-1 font-size-18">{{ 'tickets.page.ticket.title' | translate }}</h5>
          @if (gameDetails$ | async; as gameDetails) {
            @if (gameDetails.isPastGame) {
              <p class="font-size-14 mb-4" [innerHtml]="'tickets.page.ticket.past.game.instruction' | translate"></p>
            } @else if (gameDetails.status === ticketStatus.NOT_OPEN) {
              <p class="font-size-14 mb-4" [innerHtml]="'tickets.page.ticket.not.open.instruction' | translate"></p>
            } @else {
              <p class="font-size-14 mb-4" [innerHtml]="'tickets.page.ticket.closed.instruction' | translate"></p>
            }
          }
        }
        <!-- Available ticket list -->
        <fgbcl-ticket-list
          [filters]="activeFilter"
          [sortOptions]="sortOptions"
          [transferWindowExists]="transferWindowExist$ | async"
          [transferWindowOpen]="isWindowOpen$ | async"
          ticketColumn1="AreaLine1"
          ticketColumn2="StandName"
          (onDataChange)="onActiveDataSourceChange($event)"
        ></fgbcl-ticket-list>

        @if (showTransferTitle) {
          <h5 class="fw-bold mb-1 font-size-18">{{ 'tickets.page.ticket.transferred.title' | translate }}</h5>
          <p class="font-size-14 mb-4" [innerHtml]="'tickets.page.ticket.transferred.instruction' | translate"></p>
        }
        <!-- Transferred ticket list -->
        <fgbcl-ticket-list
          [filters]="transferredFilter"
          [sortOptions]="sortOptions"
          [transferWindowExists]="transferWindowExist$ | async"
          [transferWindowOpen]="isWindowOpen$ | async"
          ticketColumn1="AreaLine1"
          ticketColumn2="StandName"
          (onDataChange)="onTransferredDataChange($event)"
        ></fgbcl-ticket-list>
      </ng-container>
    </ng-container>
    <ng-template #noTickets>
      <h5>{{ 'ticket.page.no.items.title' | translate }}</h5>
      <div class="tickets-page-no-items-placeholder">
        <span class="no-items-placeholder-message">{{ 'tickets.page.no.items.placeholder.message' | translate }}</span>
      </div>
    </ng-template>
  </ng-container>
</div>

<!-- No data placeholder -->
<ng-template #noData let-message>
  <div class="ticket-selection-list-no-data">
    <p class="ticket-selection-list-no-data-message">{{ message }}</p>
  </div>
</ng-template>

<fgbcl-ticket-transfer-select-bar />
